<template>
    <section class="mail tekst video-embed light purple">
        <circles-layout></circles-layout>

        <img src="/static/img/ogt-logo.png" alt="" class="logo"/>

        <ogt-video ref="video" src="/static/video/ogt-introvideo.mp4?v3" :muted="false"></ogt-video>

        <button @click="routeToWebsite">Bekijk het Jaarverslag</button>
    </section>
</template>

<style lang="scss" scoped>
     // see /static/scss/pages/introVideo.scss
</style>

<script>
    import OgtVideo from '@/app/components/OgtVideo';
    import Circles from '@/app/components/circles';

    export default {
        name: 'IntroVideo',
        meta: {
            title: '2. Wij zijn Onderwijsgroep Tilburg',
            color: '#a5147e'
        },
        components: {
            'ogt-video': OgtVideo,
            'circles-layout': Circles
        },

        mounted()
        {
            this.focus();
        },
        methods: {
            focus()
            {
                this.$refs.video.play();
            },
            routeToWebsite()
            {
                this.$router.push( '/' );
            }
        }
    };
</script>
